import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Tell Us About Your Property",
    body: "Fill out our short form or give us a call. All we need is the property location and a few basic details. It takes about two minutes.",
  },
  {
    n: "02",
    title: "Get Your Cash Offer",
    body: "We research your property, the market, and comparable land sales, then present a fair, transparent cash offer within 48 hours. No obligation, no pressure — the decision is always yours.",
  },
  {
    n: "03",
    title: "Close On Your Timeline",
    body: "Accept when you’re ready. A licensed title company handles the paperwork and escrow, we cover standard closing costs, and you get paid — often in as little as two weeks.",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      className="relative section-pad"
      style={{ background: "#FAF7F2" }}
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="max-w-2xl"
        >
          <p className="eyebrow" data-testid="how-eyebrow">Selling Made Simple</p>
          <h2
            className="font-heading font-medium mt-4"
            style={{
              fontSize: "clamp(2rem, 4vw, 3.4rem)",
              lineHeight: 1.1,
              color: "#122B20",
              letterSpacing: "-0.015em",
            }}
            data-testid="how-headline"
          >
            Three Steps. <span className="gold-italic">Zero Hassle.</span>
          </h2>
          <p
            className="mt-5 font-body text-[#2B2926]/85"
            style={{ fontSize: "1.05rem", lineHeight: 1.7 }}
          >
            We’ve stripped everything painful out of selling property. No
            listings, no showings, no strangers walking through your home or
            your land, no six-month wait.
          </p>
        </motion.div>

        <div className="relative mt-16 md:mt-20">
          {/* Desktop connecting line */}
          <div
            className="hidden md:block absolute top-[3.5rem] left-[16.66%] right-[16.66%] h-px"
            style={{
              background:
                "linear-gradient(90deg, rgba(198,161,91,0) 0%, rgba(198,161,91,0.55) 20%, rgba(198,161,91,0.55) 80%, rgba(198,161,91,0) 100%)",
            }}
          />

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={{
              hidden: {},
              show: { transition: { staggerChildren: 0.12 } },
            }}
            className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative"
          >
            {steps.map((s, i) => (
              <motion.article
                key={s.n}
                variants={{
                  hidden: { opacity: 0, y: 24 },
                  show: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                className="glass-light p-8 md:p-9 relative overflow-hidden"
                data-testid={`how-step-${s.n}`}
              >
                <div
                  className="font-heading font-medium mb-6 leading-none"
                  style={{
                    fontSize: "2.6rem",
                    color: "#C6A15B",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {s.n}
                </div>
                <h3
                  className="font-heading font-medium text-2xl"
                  style={{ color: "#122B20" }}
                >
                  {s.title}
                </h3>
                <p
                  className="mt-4 font-body text-[#2B2926]/85"
                  style={{ fontSize: "0.98rem", lineHeight: 1.7 }}
                >
                  {s.body}
                </p>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
